module.exports = __webpack_public_path__ + "static/media/Screenshot_app_6.55aa9f53.png";